import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { OptionsService } from '../../options/services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setComplexRulesCount } from '../store/completeChart.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { CrewConstants } from '../../crew/store/crew.constants'
import { HomeConstants } from '../../home/store/home.constants'
export function* getComplexRulesCount() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getComplexRulesCount])
    yield put(setComplexRulesCount(response?.entity))
  } catch (e) {
    yield put(throwPcrException(`getComplexRulesCount() error: ${e}`))
  }
}
export function* getComplexRulesCountSaga() {
  yield takeLatest(
    [ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS, CrewConstants.SET_CREW_LIST, HomeConstants.GET_ALL_PCR_DOCS],
    performWithMutexHOG,
    getComplexRulesCount
  )
}
